import * as React from "react";
import Box from "@mui/material/Box";
import { Typography, Select, MenuItem } from "@mui/material";
import { connect } from "react-redux";
import FormularioFormato from "../components/FormularioFormato.js";
import { styles } from "../theme/styles";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { DatosCompradorContext } from "../context/Context.js";
import { useSSR } from "react-i18next";
function MenuAppBar(props) {
  const { userData, users } = props;
  const [folioGenerated, setFolioGenerated] = React.useState(false);
  const [reloadTipografia, setReloadTipografia] = React.useState();
  const [idGAux, setIdGAux] = React.useState(false);
  const [valorTiendaAdmin, setValorTiendaAdmin] = React.useState("");
  const [tiendaAsociadaAuxiliar, setTiendaAsociadaAuxiliar] =
    React.useState(true);
  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext, //modificar en base a admin o no
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    idbuscadoContext,
    setIdbuscadoContext,
    setTiendaAsociadaAuxiliarContext,
    tiendaAsociadaAuxiliarContext,
    mostrarSelectTienda,
    setMostrarSelectTienda,
  } = React.useContext(DatosCompradorContext);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (rolContext == "" && tiendaAsociadaContext == "") {
      navigate("/home");
    }
    if (rolContext == "ADMIN") {
      setTiendaAsociadaContext("");
    } else {
    }
  }, []);

  const getLastFolio = async () => {
    const insertarFolioM = await axios.post(
      `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/folios/crearFolio`,
      {
        tienda: tiendaAsociadaContext,
        idVendedor: userData.idNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
          "Content-Type": "application/json",
        },
      }
    );
    await setFolioGenerated(!folioGenerated);
    const ultimoFolioRegistrado = await axios.post(
      `${process.env.REACT_APP_BACK_APIVENTAANIMALES}/folios/consultarUltimoFolio`,
      {
        tienda: tiendaAsociadaContext,
      },
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_AUTHPETCOMPLETE}`,
          apikey: `${process.env.REACT_APP_APIKEYPETCOMPLETE}`,
          "Content-Type": "application/json",
        },
      }
    );
    // localStorage.setItem("idGenerado", ultimoFolioRegistrado.data.folio);
    setIdGeneradoContext(ultimoFolioRegistrado.data.folio);
    setReloadTipografia(!reloadTipografia);
  };

  const handleTiendaAdmin = (e) => {
    setTiendaAsociadaContext(`${e.target.value}`);
    setTiendaAsociadaAuxiliarContext(false);
    return;
  };

  const getTodayDate = () => {
    const fechaActual = new Date();
    return fechaActual;
  };

  const handleReloadTipografia = () => {
    setReloadTipografia(!reloadTipografia);
  };

  function fixFolio(str) {
    return str.replace(/_(?=[^_]*$)/, "");
  }

  return (
    <div style={styles.divform}>
      <Typography
        key={reloadTipografia}
        variant="h5"
        color="primary"
        style={styles.reportestitle2}>
        Formulario de venta de animales<br></br>
      </Typography>
      <div style={styles.formato_div}>
        <div style={{ display: "flex" }}>
          {rolContext == "STORE" && (
            <span>Sucursal: {tiendaAsociadaContext}</span>
          )}
        </div>

        <div>
          {rolContext == "ADMIN" && mostrarSelectTienda && (
            <>
              <span>Selecciona una tienda:</span>
              <Select
                style={{
                  height: "20px",
                  color: "black",
                  width: "auto",
                  marginRight: 0,
                  marginLeft: "2%",
                }}
                sx={{
                  "& .MuiSelect-select": {
                    paddingLeft: 3,
                    paddingRight: 1, // elimina el espacio entre el icono y el texto
                  },
                  "& .MuiSvgIcon-root": {
                    color: "black", // cambia el color del icono
                    position: "absolute", // posiciona el icono de manera absoluta
                    left: "0px", // alinea el icono a la izquierda
                  },
                }}
                value={tiendaAsociadaContext}
                onChange={handleTiendaAdmin}>
                {users
                  .filter((item) => item.typeUser === "STORE") // Filtrar solo los usuarios de tipo "STORE"
                  .map((item) => (
                    <MenuItem key={item._id} value={item.idNumber}>
                      {item.idNumber}
                    </MenuItem>
                  ))}
              </Select>
            </>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "right",
          }}>
          {idGeneradoContext && (
            <span style={styles.formato_tienda}>
              Folio:
              <span style={{ marginLeft: "1%" }}>
                {fixFolio(idGeneradoContext)}
              </span>
            </span>
          )}
        </div>
      </div>
      <FormularioFormato disabled={tiendaAsociadaContext ? false : true} />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    userData: state.users.data,
    users: state.users.users,
  };
};

const creators = {};

export default connect(mapStateToProps, creators)(MenuAppBar);
